import {
  Body,
  Center,
  Flex,
  Grid,
  Heading,
  calc,
  useTheme,
} from '@hover/blueprint';
import React from 'react';
import { Trans } from 'react-i18next';

import { Button } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import { useHomeownerAppContext } from '../../hooks/useHomeownerAppContext';
import { HomeownerAppMenuNames } from '../../providers/HomeownerAppProvider';
import { desktopNavbarHeight, mobileNavbarHeight } from '../Navbar';

import { ImageGrid } from './ImageGrid';

const templateAreas = {
  base: `
    'image'
    'headline'
  `,
  tablet: `'headline image'`,
};

const templateColumns = {
  base: '1fr',
  tablet: '1fr 1fr',
  desktop: '1fr 1.5fr',
};

const templateRows = {
  base: '1fr auto ',
  tablet: 'auto',
};

const LoggedOutFavorites = () => {
  const { breakpoints, space } = useTheme();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { setCurrentMenu, trackingData } = useHomeownerAppContext();

  return (
    <Center
      alignItems={{ base: 'start', tablet: 'center' }}
      left={0}
      minHeight={{
        base: 'auto',
        tablet: `calc(100vh - ${desktopNavbarHeight}px)`,
      }}
      position="relative"
      top={0}
      width={{ base: '100vw', tablet: 'auto' }}
    >
      <Grid
        bottom={0}
        boxSizing="border-box"
        data-testid="logged-out-home-grid"
        gap={{ base: 600, tablet: 300 }}
        justifyContent="center"
        maxWidth={{
          base: `calc(${breakpoints.width500} + ${space[800]} * 2)`,
          tablet: breakpoints.width500,
        }}
        minHeight={{ base: 'var(--chakra-vh)', tablet: 800 }}
        px={{ base: 0, tablet: 800 }}
        templateAreas={templateAreas}
        templateColumns={templateColumns}
        templateRows={templateRows}
        top={0}
        w="100vw"
      >
        <Flex
          alignItems="flex-end"
          gridArea="image"
          justifyContent="flex-start"
          maxWidth={0}
          pl={{ base: '120px', tablet: 0 }}
          transform={{ base: 'translateX(32%)', tablet: 'translateY(-50px)' }}
        >
          <ImageGrid />
        </Flex>

        <Flex
          alignItems="start"
          direction="column"
          gap={{ base: 200, desktop: 300 }}
          gridArea="headline"
          pb={{
            base: calc.add(`${mobileNavbarHeight}px`, space[400]),
            tablet: 700,
          }}
          px={{ base: 500, tablet: 'unset' }}
        >
          <Heading as="h1" mb="0 !important" size={{ base: 700, tablet: 900 }}>
            <Trans i18nKey="favorites.saveYourFavoriteIdeas" t={t} />
          </Heading>
          <Body
            color="neutral.600"
            m={0}
            opacity={0.8}
            width={{ base: '90%', tablet: '75%' }}
          >
            {t('favorites.signUpOrLogInToKeepYourHomeRenovation')}
          </Body>
          <Button
            mt={{ base: 200, tablet: 500 }}
            onClick={() => setCurrentMenu(HomeownerAppMenuNames.SIGN_IN)}
            optionalTrackingProperties={{
              ...trackingData,
              button_location: 'mid-left-main-page',
              track_id: 'add-photo-landing-page-button',
            }}
            size="large"
            width={{ base: '100%', tablet: 'auto' }}
          >
            {t('favorites.signUpOrLogIn')}
          </Button>
        </Flex>
      </Grid>
    </Center>
  );
};

export { LoggedOutFavorites };
